// «Рынок → Аналитика»: подписи и раскладка ответа `/cabinet/prices/analytics`.

import type { ChainRow } from '../api'

/** Звенья по порядку от борта к полке; подпись — `prices.link.<звено>`. */
export const LINK_ORDER = ['wholesale_foreign', 'import', 'export', 'wholesale_ru', 'internal',
  'horeca', 'retail']

export function linkKey(link: string): string {
  return `prices.link.${LINK_ORDER.includes(link) ? link : 'misc'}`
}

/** Доля освоения квоты, %; без квоты — null (а не ноль). */
export function utilPct(quota: number, caught: number): number | null {
  return quota > 0 ? Math.round((caught / quota) * 1000) / 10 : null
}

/** Месяцы сезонности по порядку 1…12; профиль — отклонение от средней года, %. */
export function seasonRow(profile: Record<string, number>): { month: number; pct: number }[] {
  return Object.entries(profile)
    .map(([m, v]) => ({ month: Number(m), pct: Math.round((v - 1) * 1000) / 10 }))
    .sort((a, b) => a.month - b.month)
}

/** Группа подписывается группой, своя позиция — без пометки. */
export function isGroupRow(r: ChainRow): boolean {
  return r.group
}
